import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import Artists from "./Artists";
import Map from "./Map";
import Program from "./Program";
import Sponsors from "./Sponsors";

const Body = ({ concert, t, i18n, renderBody, isExpired }) => {
  const isEnglish = (i18n.language || "it").startsWith("en");
  const intro = isEnglish ? (concert.intro_en || concert.intro_it) : (concert.intro_it || concert.intro_en);

  const isDedication = (text) => {
    if (!text) return false;
    const lower = text.trim().toLowerCase();
    return (
      lower.startsWith("concerto dedicato") ||
      lower.startsWith("concert dedicated") ||
      lower.startsWith("dedicato") ||
      lower.startsWith("dedicated") ||
      lower.startsWith("in memoria") ||
      lower.startsWith("in memory") ||
      lower.startsWith("omaggio") ||
      lower.startsWith("homage") ||
      lower.includes("concerto dedicato") ||
      lower.includes("concert dedicated") ||
      lower.includes("dedicato ad aldo belli") ||
      lower.includes("dedicated to aldo belli")
    );
  };

  const renderConcertIntro = (text) => {
    if (!text) return null;
    const lines = text.split(/\n+/).map((line) => line.trim()).filter(Boolean);

    return lines.map((line, index) => {
      if (isDedication(line)) {
        return (
          <div className="concert-dedication-card" key={index}>
            <div className="dedication-badge">
              <FontAwesomeIcon icon={faBookmark} className="dedication-icon" />
              <span>{isEnglish ? "Dedication" : "Dedica"}</span>
            </div>
            <p className="dedication-text">{line}</p>
          </div>
        );
      }
      return (
        <p key={index} className="concert-intro-text">
          {line}
        </p>
      );
    });
  };

  return (
    <section className="section">
      <div className="container">
        {intro && (
          <div className="concert-intro-wrapper mb-4">
            {renderConcertIntro(intro)}
          </div>
        )}
        <Artists concert={concert} t={t} i18n={i18n} />
        <Program concert={concert} t={t} />
      </div>
      {!isExpired && !!concert.map_link && (
        <Map map_link={concert.map_link} t={t} />
      )}
      <Sponsors
        sponsor_img={concert.sponsor_img}
        sponsor_img_width={concert.sponsor_img_width}
        t={t}
      />
    </section>
  );
};

export default Body;
